// ======================================================================
// File Name       : ContentConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const DataAffiliationType = [
  { name: '選択なし', value: 0 },
  { name: '自サービスコンテンツ', value: 1 },
  { name: '外部コンテンツ', value: 2 },
];

export const ContentSortType = {
  contentSecernId: 0,
  contentName: 1,
  videoStatus: 2,
  createdAt: 3,
  dataAffiliationType: 4,
};

export const DATA_AFFIILIATION_TYPE = {
  NOT_SELECT: -1,
  INTERNAL: 0,
  EXTERNAL: 1,
};

export const DATA_AFFIILIATION_TYPE_STR = {
  NOT_SELECT: '-1',
  INTERNAL: '0',
  EXTERNAL: '1',
};

export const CONTENT_TYPE_NAME_LIST = ['drill', 'video', 'doc', 'link'];

export const CONTENT_TYPE = {
  VIDEO: 0,
  DRILL: 1,
  QUESTION: 2,
  DOCUMENT: 3,
  LINK: 5,
};

export const DATA_AFFIILIATION_TYPE_TEXT = [
  { name: '', value: 0 }, // Display text as empty for internal contents
  { name: '外部', value: 1 },
];

export const CONTENT_QUESTION_KIND = {
  NO_TYPE: '-1',
  SINGLE_QUESTION: '0',
  BIG_QUESTION: '1',
};

export const CONTENT_DRILL_OBJECT = {
  DO_NOT_USE: 0,
  DRILL_PRIORITY: 1,
  QUESTION_PRIORITY: 2,
};

export const CONTENT_NOTIFICATION_DETAIL_TYPE = {
  PAGE: 0,
  DIALOG: 1,
};

export const DOCUMENT_EDIT_TYPE = {
  REGISTER: 0,
  UPDATE: 1,
  DELETE: 2,
};

export const DocumentUpdateType = [
  { name: 'アップロード中', value: 0 },
  { name: 'アップロード済', value: 1 },
  { name: 'アップロード失敗', value: 2 },
];

export const ANSWER_FORMULA = {
  SELECTIVE_SINGLE_ANSWER: '0',
  SELECTIVE_MULTIPLE_ANSWER: '1',
  SELECTIVE_SORT_ANSWER: '2',
  DESCRIPTIVE_SINGLE_ANSWER: '3',
  DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT: '4',
  DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER: '5',
  DESCRIPTIVE_MULTIPLE_ANSWER_ORDER: '6',
  DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER: '7',
};

export const ANSWER_FORMULA_NUM = {
  SELECTIVE_SINGLE_ANSWER: 0,
  SELECTIVE_MULTIPLE_ANSWER: 1,
  SELECTIVE_SORT_ANSWER: 2,
  DESCRIPTIVE_SINGLE_ANSWER: 3,
  DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT: 4,
  DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER: 5,
  DESCRIPTIVE_MULTIPLE_ANSWER_ORDER: 6,
  DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER: 7,
};

export const CONTENT_DRILL_TYPE = {
  DRILL_MODE: 0,
  TEST_MODE: 1,
  CORRECTION_MODE: 2,
  ADAPTIVE_MODE: 3,
};

export const DRILL_TYPE_ID = {
  NORMAL: 0,
  REANSWER: 1,
  TEST: 2,
  ADAPTIVE: 4,
  CORRECTION: 5,
  QUESTIONNAIRE: 6, // #7269
};

export const DRILL_TYPE_NAME = {
  NORMAL: 'ノーマルモード',
  REANSWER: '再解答モード',
  TEST: 'テストモード',
  ADAPTIVE: 'アダプティブモード',
  CORRECTION: '添削モード',
  QUESTIONNAIRE: 'アンケートモード', // #7269
};

export const CONVERT_STATUS = {
  START_CONVERSION: 0,
  CONVERTING: 1,
  CONVERSION_SUCCESS: 2,
  CONVERSION_ERROR: 3,
};

export const SKIN_SECERN_ID_DEFAULT = ['1', '2', '3'];

export const VIDEO_STATUS = {
  NEW: 0,
  ONLINE: 2,
  PROCESSING: 4,
  FAILED: 5,
  UPLOAD_FAILED: 7,
};

export const DOC_ACCEPT_FILE = 'pdf,zip,docx,pptx';

export const DOC_ACCEPT_TYPE = '.pdf,.zip,.docx,.pptx';

export const MULTI_DOCUMENT_ACCEPT_FILE = 'docx,pptx';

export const MULTI_DOCUMENT_ACCEPT_TYPE = '.docx,.pptx';

export const PDF_ACCEPT_FILE = 'pdf';

export const PDF_ACCEPT_TYPE = '.pdf';

export const CONFIG_FILE_ACCEPT_FILE = 'zip';

export const DISTRIBUTION_OFFER_TYPE = {
  COURSE: 0,
  CONTENT: 1,
};

export const INPUT_LIMIT_LONG_ANSWER_DEFAULT = 200;

export const UPLOAD_VIDEO_SUCCESS = 100;

export const VIDEO_DEFAULT_SIZE = {
  WIDTH: 640,
  HEIGHT: 360,
};

export const MAX_GROUP_QUESTION = 100;

export const MULTI_LANGUAGE_STATUS = {
  ALL: '',
  AVAILABLE: '0',
  TRANSLATING_CONVERTING: '1',
  UNSELECT: '2',
};

export const MULTI_LANGUAGE_STATUS_NAME = [
  { name: '利用可能', value: 0 },
  { name: '変換中', value: 1 },
  { name: '未選択', value: 2 },
];

/**
 * ドキュメントダウンロード種別 0: pdf, 1: zip, 2: docx, 3: pptx
 */
export const DOCUMENT_TYPE_DOCX_PPTX = Array.of(2, 3);

export const PROCESS_STATUS = {
  SUCCESS: 0,
  PROCESSING: 1,
  FAILED: 2,
};

export const PROCESS_STATUS_NAME = [
  { name: '成功', value: 0 },
  { name: '処理中', value: 1 },
  { name: 'エラー', value: 2 },
];

export const PROCESS_RESULT_STATUS_NAME = [
  { name: '翻訳', value: 0 },
  { name: 'ファイル変更', value: 1 },
];

export const LINE_SEPARATOR = '<br>';

// Step 7.0 No.4 START
export const VIDEO_REPLACEMENT_FLAG = {
  NO_UPDATE: 0,
  UPDATE: 1,
};
// Step 7.0 No.4 END

export const CONTENT_TYPE_STR = {
  DRILL: 'drill',
  VIDEO: 'video',
  DOCUMENT: 'doc',
  LINK: 'link',
};

// STEP10.0.0 START
export const QUESTION_SELECT_METHOD = {
  SPECIFIED_ORDER : 0,
  RANDOM: 1,
}

export const QUESTION_SELECT_METHOD_LIST = [
  { name: '指定順', value: 0 },
  { name: 'ランダム', value: 1 },
];
// STEP10.0.0 END